import AodObject from './AodObject';

export default function ProjectItem(record, aodService)
{
    AodObject.call(this, record, aodService, 'ProjectItem');
    this.isGetty();
}

ProjectItem.prototype = Object.create(
    AodObject.prototype,
    {
        getThumbUrl: {
            value: function getThumbUrl(size)
            {
                let url = 'images/default_item.png' ;  //TBD default empty Project

                if (this.thumbUrl) {
                    url = this.thumbUrl;  // Cheating -stuffed whole url in
                }
                else if (this.metroName) {
                    // todo abstract this dependency
                    //url = mcc.getUrl( 'thumb.jpg', {FILENAME: this.metroName});
                    url = this.aodService.getMccUrl( 'thumb.jpg', {FILENAME: this.metroName});
                }

                return url;
            }
        },
        isGetty: {
            value: function isGetty()
            {
                if (this.getty === undefined)
                {
                    this.getty = /^getty/i.test(this.metroName);
                    // TEMP untilwecan cache more fields
                    this.type = /videos/i.test(this.thumbUrl) ? 'videos' : 'images';
                }
                return this.getty;
            }
        }
    }
);

ProjectItem.prototype.constructor = ProjectItem;